const initialState = {
  versions: [],
  saveCrashReportPending: false,
  saveCrashReportError: null,
  loadProjectVersionPending: false,
  loadProjectVersionError: null,
};

export default initialState;
